/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';
import loadable from 'react-loadable';
// import loadable from '@loadable/component';
import Skeleton from '../Skeleton';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../assets/scss/true4oil.scss';
import '../assets/scss/servicepage.scss';

const LoadingDiv = () => <Skeleton />;

import TvsHeader from '../components/Feature/TvsHeader/TvsHeader';

const TvsImage = loadable({
  loader: () => import('../components/Feature/TvsImage/TvsImage'),
  loading: LoadingDiv,
});

TvsImage.preload();

const CorporateLayout = loadable({
  loader: () => import('../components/Project/Layouts/Corporate/CorporateLayout'),
  loading: LoadingDiv,
});
CorporateLayout.preload();

const TvsCountryDropDown = loadable({
  loader: () => import('../components/Feature/TvsCountryDropDown/TvsCountryDropDown'),
  loading: LoadingDiv,
});

const Banner = loadable({
  loader: () => import('../components/Feature/Banner/Banner'),
  loading: LoadingDiv,
});
Banner.preload();

const TextHighlight = loadable({
  loader: () => import('../components/Feature/Highlight/TextHighlight'),
  loading: LoadingDiv,
});
TextHighlight.preload();

const Carousel = loadable({
  loader: () => import('../components/Feature/Carousel/Carousel'),
  loading: LoadingDiv,
});
Carousel.preload();

const DisplayCards = loadable({
  loader: () => import('../components/Feature/DisplayCards/DisplayCards'),
  loading: LoadingDiv,
});
DisplayCards.preload();

const MakesBatter = loadable({
  loader: () => import('../components/Feature/MakesBatter/MakesBatter'),
  loading: LoadingDiv,
});
MakesBatter.preload();

const Certificate = loadable({
  loader: () => import('../components/Feature/Certificate/Certificate'),
  loading: LoadingDiv,
});
Certificate.preload();

const Product = loadable({
  loader: () => import('../components/Feature/Product/Product'),
  loading: LoadingDiv,
});
Product.preload();

const Testimonial = loadable({
  loader: () => import('../components/Feature/Testimonial/Testimonial'),
  loading: LoadingDiv,
});
Testimonial.preload();

const EngineOil = loadable({
  loader: () => import('../components/Feature/EngineOil/EngineOil'),
  loading: LoadingDiv,
});
EngineOil.preload();

const CustomerCare = loadable({
  loader: () => import('../components/Feature/CustomerCare/CustomerCare'),
  loading: LoadingDiv,
});
CustomerCare.preload();

const DiscoverService = loadable({
  loader: () => import('../components/Feature/DiscoverService/DiscoverService'),
  loading: LoadingDiv,
});
DiscoverService.preload();

const Faq = loadable({
  loader: () => import('../components/Feature/Faq/Faq'),
  loading: LoadingDiv,
});
Faq.preload();

const HeroBanner = loadable({
  loader: () => import('../components/Feature/HeroBanner/HeroBanner'),
  loading: LoadingDiv,
});
HeroBanner.preload();

const SubNavigation = loadable({
  loader: () => import('../components/Feature/SubNavigation/SubNavigation'),
  loading: LoadingDiv,
});
SubNavigation.preload();

const Tips = loadable({
  loader: () => import('../components/Feature/Tips/Tips'),
  loading: LoadingDiv,
});
Tips.preload();

const UserManual = loadable({
  loader: () => import('../components/Feature/UserManual/UserManual'),
  loading: LoadingDiv,
});
UserManual.preload();

const TvsCare = loadable({
  loader: () => import('../components/Feature/Tvscare/TvsCare'),
  loading: LoadingDiv,
});
TvsCare.preload();

const TvsGenuine = loadable({
  loader: () => import('../components/Feature/TvsGenuine/TvsGenuine'),
  loading: LoadingDiv,
});
TvsGenuine.preload();

const TvsSearchResults = loadable({
  loader: () => import('../components/Feature/TvsSearchResults/TvsSearchResults'),
  loading: LoadingDiv,
});
TvsSearchResults.preload();

const TrendingProducts = loadable({
  loader: () => import('../components/Feature/TrendingProducts/TrendingProducts'),
  loading: LoadingDiv,
});
TrendingProducts.preload();

const LatestBlogs = loadable({
  loader: () => import('../components/Feature/LatestBlogs/LatestBlogs'),
  loading: LoadingDiv,
});
LatestBlogs.preload();

const ContactUs = loadable({
  loader: () => import('../components/Feature/ContactUs/ContactUs'),
  loading: LoadingDiv,
});
ContactUs.preload();

const TVSCTAs = loadable({
  loader: () => import('../components/Feature/TvsCommonHeader/TVSCTAs'),
  loading: LoadingDiv,
});
TVSCTAs.preload();

const TvsCommonHeader = loadable({
  loader: () => import('../components/Feature/TvsCommonHeader/TvsCommonHeader'),
  loading: LoadingDiv,
});
TvsCommonHeader.preload();
const StickyButton = loadable({
  loader: () => import('../components/Feature/StickyButton/StickyButton'),
  loading: LoadingDiv,
});
StickyButton.preload();

const ProductListing = loadable({
  loader: () => import('../components/Feature/PLP/ProductListing'),
  loading: LoadingDiv,
});
ProductListing.preload();

const Breadcrumbs = loadable({
  loader: () => import('../components/Feature/Breadcrumbs/Breadcrumbs'),
  loading: LoadingDiv,
});
Breadcrumbs.preload();

const TvsHeadlessNewFooter = loadable({
  loader: () => import('../components/Feature/TvsHeadlessNewFooter/TvsHeadlessNewFooter'),
  loading: LoadingDiv,
});

// Home
const Home = loadable({
  loader: () => import('../components/Feature/Home/Home'),
  loading: LoadingDiv,
});
Home.preload();

// RVSF Main
const RvsfMain = loadable({
  loader: () => import('../components/Feature/Rvsf/RvsfMain/RvsfMain'),
  loading: LoadingDiv,
});
RvsfMain.preload();

// Benefits Section
const BenefitsSection = loadable({
  loader: () => import('../components/Feature/Rvsf/BenefitsSection/BenefitsSection'),
  loading: LoadingDiv,
});
BenefitsSection.preload();

// ELV Section
const ELVSection = loadable({
  loader: () => import('../components/Feature/Rvsf/ELVSection/ELVSection'),
  loading: LoadingDiv,
});
ELVSection.preload();

// Returns Section
const ReturnsSection = loadable({
  loader: () => import('../components/Feature/Rvsf/ReturnsSection/ReturnsSection'),
  loading: LoadingDiv,
});
ReturnsSection.preload();

// Scrapping Section
const ScrappingSection = loadable({
  loader: () => import('../components/Feature/Rvsf/ScrappingSection/ScrappingSection'),
  loading: LoadingDiv,
});
ScrappingSection.preload();

const components = new Map();

components.set('TvsCountryDropDown', TvsCountryDropDown);
components.set('TvsHeader', TvsHeader);
components.set('TvsHeadlessNewFooter', TvsHeadlessNewFooter);
components.set('TvsImage', TvsImage);
components.set('Banner', Banner);
components.set('TextHighlight', TextHighlight);
components.set('Carousel', Carousel);
components.set('DisplayCards', DisplayCards);
components.set('MakesBatter', MakesBatter);
components.set('Certificate', Certificate);
components.set('Product', Product);
components.set('Testimonial', Testimonial);
components.set('EngineOil', EngineOil);
components.set('CustomerCare', CustomerCare);
components.set('DiscoverService', DiscoverService);
components.set('ProductListing', ProductListing);
components.set('Breadcrumbs', Breadcrumbs);
components.set('ContactUs', ContactUs);
components.set('Faq', Faq);
components.set('HeroBanner', HeroBanner);
components.set('SubNavigation', SubNavigation);
components.set('Tips', Tips);
components.set('TvsCare', TvsCare);
components.set('TvsGenuine', TvsGenuine);
components.set('TvsSearchResults', TvsSearchResults);
components.set('TrendingProducts', TrendingProducts);
components.set('LatestBlogs', LatestBlogs);
components.set('UserManual', UserManual);
components.set('TvsCommonHeader', TvsCommonHeader);
components.set('TVSCTAs', TVSCTAs);
components.set('StickyButton', StickyButton);
components.set('CorporateLayout', CorporateLayout);
components.set('Home', Home);
components.set('RvsfMain', RvsfMain);
components.set('BenefitsSection', BenefitsSection);
components.set('ELVSection', ELVSection);
components.set('ReturnsSection', ReturnsSection);
components.set('ScrappingSection', ScrappingSection);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();

